/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Static-mode replacement for `@salesforce/storefront-next-runtime/i18n/client`.
 * Aliased in for `I18N_MODE=static` so the runtime's client i18next initializer
 * (which pulls in i18next core, react-i18next, and the language detector) never
 * enters the client bundle.
 *
 * `initI18next` returns the shared English shim instance. Because
 * `staticI18nInstance.hasResourceBundle()` is always true, `whenI18nReady()` in
 * `i18n-client-init.ts` resolves immediately and hydration is no longer gated on
 * an async locale fetch.
 */
import { staticI18nInstance, type StaticI18n } from './react-i18next-shim';

export function initI18next(_options?: { language?: string; instance?: unknown; loadLocale?: unknown }): StaticI18n {
    return staticI18nInstance;
}
